import { Koi } from '@ksyos/koi';
import { CarePathActivityConditionField, CarePathActivityConditionRestriction } from '@common/enums';
import type { ISchemaContainer } from './schemaContainer';

export interface IServiceDeclarationActivityAddEditValidated {
    activityType: string;
    appliesWhenCustomControlDataQuery: string | null;
    codeActiviteit: string;
    codeAfsluitreden: string | null;
    codeDiagnose: string | null;
    codeSpecialisme: string | null;
    codeZorgtype: string | null;
    conditionField: CarePathActivityConditionField | null;
    conditionRestriction: CarePathActivityConditionRestriction | null;
    defaultIcd10Code: string | null;
    isHonorariumDeclareren: boolean;
    isKostendeelDeclareren: boolean;
    serviceId: string;
}

export const serviceDeclarationActivityAddEditSchema: ISchemaContainer<IServiceDeclarationActivityAddEditValidated> = {
    schema: Koi.object({
        activityType: Koi.string().max(255),
        appliesWhenCustomControlDataQuery: Koi.string().max(255).allow(null, ''),
        codeActiviteit: Koi.string().max(255),
        codeAfsluitreden: Koi.string().max(255).allow(null, ''),
        codeDiagnose: Koi.string().max(255).allow(null, ''),
        codeSpecialisme: Koi.string().max(255).allow(null, ''),
        codeZorgtype: Koi.string().max(255).allow(null, ''),
        conditionField: Koi.koi().enum(CarePathActivityConditionField).allow(null),
        conditionRestriction: Koi.when('conditionField', {
            is: null,
            otherwise: Koi.koi().enum(CarePathActivityConditionRestriction).disallow(null),
            then: Koi.valid(null),
        }),
        defaultIcd10Code: Koi.string().max(255).allow(null, ''),
        isHonorariumDeclareren: Koi.boolean(),
        isKostendeelDeclareren: Koi.boolean(),
        serviceId: Koi.string().uuid(),
    }).options({ convert: false, presence: 'required' }),
};
